// NHÓM 4 THAO TÁC XÂY KÊNH (07/10/2026, người dùng duyệt — RỦI RO CAO, KHÔNG BAO GIỜ HÀNG LOẠT):
//  · facebook|tiktok/tra_loi_tin_nhan — TRẢ LỜI tin nhắn CHƯA ĐỌC với tư cách chủ tài khoản: chỉ mở đoạn chat chưa đọc mà tin cuối là của NGƯỜI KIA,
//    bỏ tin rác (liên kết / chuyển khoản / quà tặng / vay tiền…) và — mặc định — người lạ (yêu cầu tin nhắn, chưa là bạn bè); AI soạn câu đáp; gõ vào ô tin nhắn
//    của đoạn chat đang mở (vùng "tin_nhan": CHỈ trên trang hộp thư /messages — src/content/dom.ts locUngVien) rồi Enter (có duyệt). Tối đa so_tin đoạn chat
//    mỗi lượt (≤ 5, mặc định 2), hạn mức riêng "tin_nhan" mỗi ngày (mặc định 5 — han-muc-ngay.ts), sổ cái theo đoạn chat + tin xem trước (không trả lời
//    trùng một tin). KHÔNG mở đầu cuộc trò chuyện, KHÔNG nhắn người chưa nhắn mình, KHÔNG gửi hàng loạt.
//    Messenger hỏi "Nhập mã PIN để khôi phục đoạn chat" (đã thấy khi khảo sát) → DỪNG, cần người nhập PIN trên máy bot (bot không bao giờ nhập PIN).
//  · x|tiktok/cap_nhat_tieu_su — sửa TIỂU SỬ hồ sơ: nguyên văn (tieu_su) hoặc AI soạn theo chủ đề; X ≤ 160 ký tự, TikTok ≤ 80; hạn mức "ho_so" 1/ngày.
//    ẢNH ĐẠI DIỆN từ Kho ảnh CHƯA làm: ô chọn tệp + hộp cắt ảnh của trang sửa hồ sơ chưa đo được trên trang thật — đặt nhầm ảnh lên hồ sơ là lỗi khó đảo
//    ngược, nên không dựng khối "đoán" selector cho việc này.
//
// ĐỐI CHIẾU KHẢO SÁT THẬT (Edge 9333/9334, 04/10/2026):
//  ĐÃ ĐO: Messenger — hộp thoại h2 "Nhập mã PIN để khôi phục đoạn chat của bạn" (messenger #16–#21); TikTok hộp thư — [data-e2e=dm-new-conversation-list] >
//         [data-e2e=dm-new-conversation-item] > [data-e2e=dm-new-conversation-nickname], khung đoạn chat [data-e2e=dm-new-chatbox] (hop_thu #26–#33);
//         X — link Hồ sơ AppTabBar_Profile_Link; TikTok — nav-profile (TT_NICK_SPEC).
//  CHƯA KIỂM TRÊN TRANG THẬT (ghi tại từng hằng): danh sách Đoạn chat Messenger (liên kết /messages/t/…, dấu "chưa đọc", "Bạn:"), khung tin nhắn + ô soạn
//    + bong bóng tin vừa gửi của Messenger, dấu người lạ / yêu cầu tin nhắn; dấu chưa đọc + ô soạn + bong bóng của TikTok; trang sửa hồ sơ X
//    (textarea[name=description], Profile_Save_Button); nút Sửa hồ sơ + ô Tiểu sử + nút Lưu của TikTok.
import type { KhoiMau } from "./tu-dung";
import { TT_NICK_SPEC } from "./tt-khoi";

const SO_TIN_TOI_DA = 5;
const TS_SO_TIN = { ten: "so_tin", moTa: `số đoạn chat CHƯA ĐỌC trả lời tối đa mỗi lượt (1-${SO_TIN_TOI_DA}; không bao giờ hàng loạt)`, kieu: "so" as const, min: 1, max: SO_TIN_TOI_DA, macDinh: "2" };
const TS_CHI_QUEN = { ten: "chi_nguoi_quen", moTa: "co = chỉ trả lời người quen (bỏ yêu cầu tin nhắn / người chưa là bạn bè); khong = trả lời cả người lạ (vẫn bỏ tin rác)", kieu: "chuoi" as const, luaChon: ["co", "khong"], macDinh: "co" };
// Tin rác / lừa đảo (đọc trên ĐOẠN CUỐI của đoạn chat): liên kết, chuyển khoản, quà tặng, vay tiền, tiền ảo, việc nhẹ lương cao… → không trả lời.
export const RE_TIN_RAC = "https?://|www\\.|bit\\.ly|tinyurl|zalo\\.me|t\\.me/|chuyển khoản|chuyen khoan|trúng thưởng|nhận quà|quà tặng miễn phí|vay tiền|vay nhanh|giải ngân|đầu tư sinh lời|lợi nhuận cao|crypto|bitcoin|USDT|việc nhẹ lương cao|bấm vào link|nhấn vào link|click (vào|the) link|xác minh tài khoản|verify your account|gift card|you have won";
const DUOI_600 = "([\\s\\S]{0,600})$"; // 600 ký tự CUỐI của khung đoạn chat (tin mới nhất ở dưới)
const DK_TRA_LOI = "len(trim(str(item.doan_cuoi))) > 0 and item.spam != 'spam' and ('{{ts.chi_nguoi_quen}}' == 'khong' or item.nguoi_la != 'la')"; // lọc đoạn chat đang mở (một mục)
const LY_DO_BO = "đoạn chat này là tin rác / lừa đảo (liên kết, chuyển khoản, quà tặng…) hoặc của người lạ (yêu cầu tin nhắn, chưa là bạn bè) — không trả lời";
const SOAN = (mang: string, tn: string) => `Đoạn cuối cuộc trò chuyện ${mang} (tin mới nhất ở cuối, của NGƯỜI KHÁC gửi cho bạn): {{str(${tn}[0].doan_cuoi)}} — (bạn là CHỦ tài khoản đang trả lời tin nhắn riêng: đáp đúng điều họ vừa hỏi/nói, ngắn gọn, lịch sự, tự nhiên như người thật; không gửi liên kết, số tài khoản, mã giảm giá; không hứa giá/giao dịch nếu kiến thức không có; không nhắc mình là máy)`;

// ===================== FACEBOOK MESSENGER =====================
const FB_PIN_SPEC = { mode: "list", list: { describe: "trang tin nhắn Facebook (hộp hỏi mã PIN khôi phục đoạn chat — một mục: cả trang)", ladder: [{ t: "css", sel: "body" }] }, fields: {
  // ĐÃ ĐO: div[role=dialog] > … h2 "Nhập mã PIN để khôi phục đoạn chat của bạn".
  pin: { sel: '[role="dialog"]', attr: "text", phan_loai: [{ re: "Nhập mã PIN|mã PIN để khôi phục|Enter your PIN|PIN to restore", gt: "pin" }], mac_dinh: "" },
} };
// CHƯA KIỂM: mỗi đoạn chat trong danh sách là liên kết /messages/t/<mã>/; chữ của dòng có "Tin nhắn chưa đọc"/"Unread message" khi chưa đọc, "Bạn:" khi tin cuối là của mình.
const FB_DS_CHAT_SPEC = {
  mode: "list",
  list: { describe: "đoạn chat trong danh sách Đoạn chat (Messenger)", ladder: [
    { t: "css", sel: '[aria-label="Đoạn chat"] a[href*="/messages/t/"]' },
    { t: "css", sel: '[aria-label="Chats"] a[href*="/messages/t/"]' },
    { t: "css", sel: 'div[role="navigation"] a[href*="/messages/t/"]' },
    { t: "css", sel: 'a[href*="/messages/t/"]' },
  ] },
  fields: {
    lien_ket: { sel: null, attr: "href" },
    khoa: { sel: null, attr: "text" },
    xem_truoc: { sel: null, attr: "text", regex: "([\\s\\S]{0,200})" },
    chua_doc: { sel: null, attr: "text", phan_loai: [{ re: "Tin nhắn chưa đọc|Chưa đọc|Unread message|Unread", gt: "co" }], mac_dinh: "" },
    tu_minh: { sel: null, attr: "text", phan_loai: [{ re: "(^|\\s)(Bạn|You):", gt: "co" }], mac_dinh: "" },
  },
  item_key: ["khoa", "lien_ket"],
};
// CHƯA KIỂM: khung tin nhắn của đoạn chat đang mở (role=log / nhãn "Tin nhắn trong cuộc trò chuyện…"), dấu yêu cầu tin nhắn / chưa là bạn bè.
const FB_KHUNG_CHAT = 'div[role="main"] [role="log"]';
const FB_KHUNG_CHAT_ALT = ['div[role="main"] [aria-label^="Tin nhắn trong cuộc trò chuyện"]', 'div[role="main"] [aria-label^="Messages in conversation"]', 'div[role="main"]'];
const FB_CHAT_MO_SPEC = { mode: "list", list: { describe: "đoạn chat đang mở trên Messenger (một mục: cả trang)", ladder: [{ t: "css", sel: "body" }] }, fields: {
  doan_cuoi: { sel: FB_KHUNG_CHAT, attr: "text", regex: DUOI_600, alt: FB_KHUNG_CHAT_ALT, mac_dinh: "" },
  spam: { sel: FB_KHUNG_CHAT, attr: "text", regex: DUOI_600, alt: FB_KHUNG_CHAT_ALT, phan_loai: [{ re: RE_TIN_RAC, gt: "spam" }], mac_dinh: "" },
  nguoi_la: { sel: 'div[role="main"]', attr: "text", phan_loai: [{ re: "Yêu cầu tin nhắn|Message request|Bạn chưa kết bạn|không phải là bạn bè|không phải bạn bè trên Facebook|You're not friends|You aren't friends|Accept message request|Chấp nhận yêu cầu", gt: "la" }], mac_dinh: "" },
} };
const FB_O_TIN_NHAN = { describe: "ô soạn tin nhắn của đoạn chat đang mở (trang hộp thư Messenger)", vung: "tin_nhan", ladder: [
  { t: "css", sel: 'div[role="main"] div[role="textbox"][contenteditable="true"][aria-label="Tin nhắn"]' },
  { t: "css", sel: 'div[role="main"] div[role="textbox"][contenteditable="true"][aria-label="Message"]' },
  { t: "css", sel: 'div[role="main"] div[role="textbox"][contenteditable="true"]' },
] };
const DA_GUI_TIN = (khung: string, bien: string) => ({ t: "locator_visible" as const, target: { describe: "tin vừa gửi hiện trong đoạn chat đang mở (không phải chữ còn trong ô soạn)", vung: "tin_nhan", ladder: [
  { t: "xpath" as const, xpath: `(${khung}//*[contains(normalize-space(.), {{ xpath_chu(dau_chu(${bien}, 40)) }})][not(ancestor-or-self::*[@contenteditable="true"])][not(*[contains(normalize-space(.), {{ xpath_chu(dau_chu(${bien}, 40)) }})])])[last()]` },
] } });
const FB_TRA_LOI_TN: KhoiMau = {
  ten: "tra_loi_tin_nhan",
  moTa: `TRẢ LỜI tin nhắn CHƯA ĐỌC trên Messenger với tư cách chủ tài khoản (rủi ro cao — có duyệt): mở hộp thư, chỉ chọn đoạn chat chưa đọc mà tin cuối là của người kia, bỏ tin rác / lừa đảo và (mặc định) người lạ, AI soạn câu đáp đúng điều họ hỏi rồi gửi. Tối đa so_tin đoạn chat mỗi lượt (≤ ${SO_TIN_TOI_DA}), hạn mức tin nhắn mỗi ngày (mặc định 5); không trả lời trùng một tin (sổ cái). KHÔNG mở đầu cuộc trò chuyện, KHÔNG nhắn hàng loạt. Messenger hỏi mã PIN khôi phục đoạn chat → dừng, cần người nhập PIN.`,
  thamSo: [TS_SO_TIN, TS_CHI_QUEN],
  trangThu: "https://www.facebook.com/messages/ (hộp PIN đo khảo sát messenger 04/10; danh sách / khung chat CHƯA kiểm)",
  yamlSteps: `  - id: mo_hop_thu_fb
    on: web
    do: "mở hộp thư Messenger"
    expect: "trang tin nhắn"

  - id: kiem_pin_fb
    on: web
    extract: "trang tin nhắn: có hộp hỏi mã PIN khôi phục đoạn chat không"
    into: trang_tn_fb
    timeout: 15s

  - id: lay_chat_fb
    on: web
    extract: "đoạn chat trong danh sách Đoạn chat: lien_ket, khoa, xem_truoc, chua_doc, tu_minh"
    into: ds_chat_fb
    timeout: 20s

  - id: chon_chat_fb
    filter: "item.chua_doc == 'co' and item.tu_minh != 'co' and len(str(item.lien_ket)) > 0 and str(item.khoa) not in ledger.da_tra_loi_tn"
    into: ds_chat_fb

  - id: tra_loi_chat_fb
    for_each: ds_chat_fb
    max_items: {{ts.so_tin}}
    on_item_error: skip
    steps:
      - id: mo_chat_fb
        on: web
        do: "mở đoạn chat {{item.lien_ket}}"
        expect: "url chứa /messages/t/"
      - id: doc_chat_fb
        on: web
        extract: "đoạn chat đang mở: doan_cuoi, spam, nguoi_la"
        into: tn_fb
        timeout: 15s
      - id: loc_tn_fb
        filter: "${DK_TRA_LOI}"
        into: tn_fb
      - id: soan_tl_tn_fb
        when: "len(tn_fb) > 0"
        ly_do_bo_qua: "${LY_DO_BO}"
        generate:
          input: "${SOAN("Messenger", "tn_fb")}"
          guide: knowledge
          max_words: 60
          max_chars: 500
        into: item.tl
      - id: gui_tl_tn_fb
        when: "len(tn_fb) > 0"
        ly_do_bo_qua: "${LY_DO_BO}"
        on: web
        do: "gõ {{item.tl}} vào ô tin nhắn của đoạn chat đang mở rồi Enter"
        expect: "tin vừa gửi hiện trong đoạn chat"
        risk: high
        idempotent: unsafe
        timeout: 60s
        ledger: da_tra_loi_tn`,
  learned: {
    mo_hop_thu_fb: { actions: [{ kind: "navigate", url: "{{goc}}messages/" }] },
    kiem_pin_fb: { extract_spec: FB_PIN_SPEC, dung_neu_sai: [{ dk: "len(trang_tn_fb) == 0 or trang_tn_fb[0].pin != 'pin'", ly_do: "Messenger đang hỏi mã PIN để khôi phục đoạn chat — cần người nhập mã PIN trên máy bot (bot không bao giờ nhập PIN), xong rồi chạy lại" }] },
    lay_chat_fb: { extract_spec: FB_DS_CHAT_SPEC, khong_viec_khi_rong: "Hộp thư Messenger chưa có đoạn chat nào — không có tin nhắn để trả lời" },
    chon_chat_fb: { ly_do_bo: "đoạn chat đã đọc, tin cuối là của mình, hoặc tin này đã được trả lời (sổ cái)" },
    tra_loi_chat_fb: { con: {
      mo_chat_fb: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }], postcondition: [{ t: "url_contains", s: "/messages/" }, { t: "locator_visible", target: FB_O_TIN_NHAN }] },
      loc_tn_fb: { ly_do_bo: LY_DO_BO },
      doc_chat_fb: { extract_spec: FB_CHAT_MO_SPEC },
      gui_tl_tn_fb: {
        actions: [{ kind: "type", target: FB_O_TIN_NHAN, text: "{{item.tl}}", clear: true }, { kind: "press", key: "Enter" }],
        postcondition: [{ t: "url_contains", s: "/messages/" }, DA_GUI_TIN('//div[@role="main"]', "item.tl")],
        dem_ngay: "tin_nhan",
      },
    } },
  },
};

// ===================== TIKTOK =====================
// ĐÃ ĐO: danh sách / mục / tên. CHƯA KIỂM: dấu chưa đọc (huy hiệu số trên mục).
const TT_DS_CHAT_SPEC = {
  mode: "list",
  list: { describe: "đoạn chat trong hộp thư TikTok", ladder: [
    { t: "css", sel: '[data-e2e="dm-new-conversation-list"] [data-e2e="dm-new-conversation-item"]' },
    { t: "css", sel: '[data-e2e="dm-new-conversation-item"]' },
  ] },
  fields: {
    ten: { sel: '[data-e2e="dm-new-conversation-nickname"]', attr: "text" },
    khoa: { sel: null, attr: "text" },
    chua_doc: { sel: '[class*="UnreadCount"], [class*="unread"], [class*="Unread"], [data-e2e*="unread"]', attr: "text", phan_loai: [{ re: "[\\s\\S]*", gt: "co" }], mac_dinh: "" },
  },
  item_key: ["khoa"],
};
const TT_KHUNG = '[data-e2e="dm-new-chatbox"]'; // ĐÃ ĐO
const TT_CHAT_MO_SPEC = { mode: "list", list: { describe: "đoạn chat TikTok đang mở (một mục: cả trang)", ladder: [{ t: "css", sel: "body" }] }, fields: {
  doan_cuoi: { sel: TT_KHUNG, attr: "text", regex: DUOI_600, alt: ["#main-content-messages"], mac_dinh: "" },
  spam: { sel: TT_KHUNG, attr: "text", regex: DUOI_600, alt: ["#main-content-messages"], phan_loai: [{ re: RE_TIN_RAC, gt: "spam" }], mac_dinh: "" },
  // CHƯA KIỂM: yêu cầu tin nhắn của người chưa follow nhau có nút Chấp nhận / Accept.
  nguoi_la: { sel: TT_KHUNG, attr: "text", alt: ["#main-content-messages"], phan_loai: [{ re: "Message request|Yêu cầu tin nhắn|wants to send you a message|muốn gửi tin nhắn cho bạn|Accept|Chấp nhận", gt: "la" }], mac_dinh: "" },
} };
// CHƯA KIỂM: ô soạn contenteditable trong khung đoạn chat.
const TT_O_TIN_NHAN = { describe: "ô soạn tin nhắn của đoạn chat TikTok đang mở (trang hộp thư)", vung: "tin_nhan", ladder: [
  { t: "css", sel: `${TT_KHUNG} [contenteditable="true"]` },
  { t: "css", sel: '[data-e2e="message-input-area"] [contenteditable="true"]' },
] };
const TT_TRA_LOI_TN: KhoiMau = {
  ten: "tra_loi_tin_nhan",
  moTa: `TRẢ LỜI tin nhắn CHƯA ĐỌC trong hộp thư TikTok với tư cách chủ tài khoản (rủi ro cao — có duyệt): chỉ đoạn chat có dấu chưa đọc, bỏ tin rác / lừa đảo và (mặc định) yêu cầu tin nhắn của người lạ, AI soạn câu đáp rồi gửi. Tối đa so_tin đoạn chat mỗi lượt (≤ ${SO_TIN_TOI_DA}), hạn mức tin nhắn mỗi ngày (mặc định 5); không trả lời trùng một tin (sổ cái). KHÔNG mở đầu cuộc trò chuyện, KHÔNG nhắn hàng loạt.`,
  thamSo: [TS_SO_TIN, TS_CHI_QUEN],
  trangThu: "https://www.tiktok.com/messages (danh sách + khung chat đo khảo sát hop_thu 04/10; dấu chưa đọc + ô soạn CHƯA kiểm)",
  yamlSteps: `  - id: mo_hop_thu_tt
    on: web
    do: "mở hộp thư TikTok"
    expect: "trang tin nhắn"

  - id: lay_chat_tt
    on: web
    extract: "đoạn chat trong hộp thư: ten, khoa, chua_doc"
    into: ds_chat_tt
    timeout: 20s

  - id: chon_chat_tt
    filter: "item.chua_doc == 'co' and str(item.khoa) not in ledger.da_tra_loi_tn_tt"
    into: ds_chat_tt

  - id: tra_loi_chat_tt
    for_each: ds_chat_tt
    max_items: {{ts.so_tin}}
    on_item_error: skip
    steps:
      - id: mo_chat_tt
        on: web
        do: "bấm đoạn chat {{item.ten}} trong danh sách"
        expect: "khung đoạn chat mở"
      - id: doc_chat_tt
        on: web
        extract: "đoạn chat đang mở: doan_cuoi, spam, nguoi_la"
        into: tn_tt
        timeout: 15s
      - id: loc_tn_tt
        filter: "${DK_TRA_LOI}"
        into: tn_tt
      - id: soan_tl_tn_tt
        when: "len(tn_tt) > 0"
        ly_do_bo_qua: "${LY_DO_BO}"
        generate:
          input: "${SOAN("TikTok", "tn_tt")}"
          guide: knowledge
          max_words: 50
          max_chars: 500
        into: item.tl
      - id: gui_tl_tn_tt
        when: "len(tn_tt) > 0"
        ly_do_bo_qua: "${LY_DO_BO}"
        on: web
        do: "gõ {{item.tl}} vào ô tin nhắn của đoạn chat đang mở rồi Enter"
        expect: "tin vừa gửi hiện trong đoạn chat"
        risk: high
        idempotent: unsafe
        timeout: 60s
        ledger: da_tra_loi_tn_tt`,
  learned: {
    mo_hop_thu_tt: { actions: [{ kind: "navigate", url: "{{goc}}messages" }] },
    lay_chat_tt: { extract_spec: TT_DS_CHAT_SPEC, khong_viec_khi_rong: "Hộp thư TikTok chưa có đoạn chat nào — không có tin nhắn để trả lời" },
    chon_chat_tt: { ly_do_bo: "đoạn chat đã đọc hoặc tin này đã được trả lời (sổ cái)" },
    tra_loi_chat_tt: { con: {
      mo_chat_tt: { actions: [{ kind: "click", target: { describe: "tên đoạn chat này trong danh sách", within: "item", ladder: [{ t: "css", sel: '[data-e2e="dm-new-conversation-nickname"]' }] } }], postcondition: [{ t: "locator_visible", target: TT_O_TIN_NHAN }] },
      loc_tn_tt: { ly_do_bo: LY_DO_BO },
      doc_chat_tt: { extract_spec: TT_CHAT_MO_SPEC },
      gui_tl_tn_tt: {
        actions: [{ kind: "type", target: TT_O_TIN_NHAN, text: "{{item.tl}}", clear: true }, { kind: "press", key: "Enter" }],
        postcondition: [{ t: "url_contains", s: "/messages" }, DA_GUI_TIN(`//*[@data-e2e="dm-new-chatbox"]`, "item.tl")],
        dem_ngay: "tin_nhan",
      },
    } },
  },
};

// ===================== TIỂU SỬ HỒ SƠ =====================
const dungTieuSu = (bien: string, nguyenVan: string, chuDe: string, toiDa: number, mang: string) => [
  { dk: `len(trim(${nguyenVan})) > 0 or len(trim(${chuDe})) > 0`, ly_do: "chưa có tiểu sử lẫn chủ đề — điền một trong hai rồi chạy lại" },
  { dk: `len(${bien}) <= ${toiDa}`, ly_do: `tiểu sử dài {{len(${bien})}} ký tự, vượt ${toiDa} ký tự (giới hạn của ${mang}) — chặn, không lưu (rút gọn rồi chạy lại)` },
];
const TS_TIEU_SU = (toiDa: number) => [
  { ten: "tieu_su", moTa: `tiểu sử NGUYÊN VĂN (tối đa ${toiDa} ký tự); bỏ trống = AI soạn theo chủ đề`, kieu: "chuoi" as const, macDinh: "" },
  { ten: "chu_de", moTa: "chủ đề để AI soạn tiểu sử (bỏ trống nếu điền sẵn tiểu sử)", kieu: "chuoi" as const, macDinh: "" },
];
// CHƯA KIỂM: trang /settings/profile mở hộp "Sửa hồ sơ" — ô Tiểu sử textarea[name=description], nút Lưu [data-testid=Profile_Save_Button].
const X_O_TIEU_SU = { describe: "ô Tiểu sử trong hộp Sửa hồ sơ X", ladder: [
  { t: "css", sel: 'textarea[name="description"]' },
  { t: "css", sel: '[role="dialog"] textarea' },
] };
const X_TIEU_SU: KhoiMau = {
  ten: "cap_nhat_tieu_su",
  moTa: "Sửa TIỂU SỬ (bio) hồ sơ X của nick: nguyên văn (tieu_su) hoặc AI soạn theo chủ đề, tối đa 160 ký tự; mở Sửa hồ sơ → gõ vào ô Tiểu sử → Lưu (rủi ro cao — có duyệt). Hạn mức sửa hồ sơ mỗi ngày (mặc định 1); cùng tiểu sử đã lưu thì không lưu lại.",
  thamSo: TS_TIEU_SU(160),
  params: {
    tieu_su_x: { type: "string", default: "{{ts.tieu_su}}", label: "Tiểu sử X (để trống = AI soạn)" },
    chu_de_ts_x: { type: "string", default: "{{ts.chu_de}}", label: "Chủ đề tiểu sử X (AI soạn)" },
  },
  trangThu: "CHƯA kiểm trên trang thật (https://x.com/settings/profile — hộp Sửa hồ sơ)",
  yamlSteps: `  - id: lay_tieu_su_x
    template: "{{tieu_su_x}}"
    into: ts_x

  - id: soan_tieu_su_x
    when: "len(trim(tieu_su_x)) == 0"
    generate:
      input: "Viết TIỂU SỬ (bio) cho hồ sơ X của chính bạn về: {{chu_de_ts_x}} — một câu ngắn, tối đa 160 ký tự, tự nhiên, không chèn liên kết hay số điện thoại"
      guide: knowledge
      max_words: 30
      max_chars: 160
    into: ts_x

  - id: mo_sua_ho_so_x
    on: web
    do: "mở hộp Sửa hồ sơ X"
    expect: "ô Tiểu sử hiện"

  - id: luu_tieu_su_x
    on: web
    do: "gõ {{ts_x}} vào ô Tiểu sử rồi bấm Lưu"
    expect: "hộp Sửa hồ sơ đóng"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_cap_nhat_tieu_su_x`,
  learned: {
    lay_tieu_su_x: { dung_neu_sai: dungTieuSu("ts_x", "tieu_su_x", "chu_de_ts_x", 160, "X") },
    soan_tieu_su_x: { dung_neu_sai: [{ dk: "len(trim(ts_x)) > 0", ly_do: "AI chưa soạn được tiểu sử — không lưu" }] },
    mo_sua_ho_so_x: { actions: [{ kind: "navigate", url: "{{goc}}settings/profile" }], postcondition: [{ t: "locator_visible", target: X_O_TIEU_SU }] },
    luu_tieu_su_x: {
      actions: [
        { kind: "type", target: X_O_TIEU_SU, text: "{{ts_x}}", clear: true },
        { kind: "click", target: { describe: "nút Lưu của hộp Sửa hồ sơ", ladder: [{ t: "css", sel: '[data-testid="Profile_Save_Button"]' }, { t: "xpath", xpath: '(//*[@role="dialog"]//button[normalize-space()="Lưu" or normalize-space()="Save"])[1]' }] } },
      ],
      postcondition: [{ t: "locator_gone", target: X_O_TIEU_SU }],
      dem_ngay: "ho_so",
    },
  },
};
// CHƯA KIỂM: nút "Sửa hồ sơ" [data-e2e=edit-profile-entrance], ô Tiểu sử (textarea trong hộp), nút Lưu [data-e2e=edit-profile-save].
const TT_O_TIEU_SU = { describe: "ô Tiểu sử trong hộp Sửa hồ sơ TikTok", ladder: [
  { t: "css", sel: '[data-e2e="edit-profile-bio-input"] textarea' },
  { t: "css", sel: '[role="dialog"] textarea' },
] };
const TT_TIEU_SU: KhoiMau = {
  ten: "cap_nhat_tieu_su",
  moTa: "Sửa TIỂU SỬ (bio) hồ sơ TikTok của nick: nguyên văn (tieu_su) hoặc AI soạn theo chủ đề, tối đa 80 ký tự; mở trang cá nhân → Sửa hồ sơ → gõ vào ô Tiểu sử → Lưu (rủi ro cao — có duyệt). Hạn mức sửa hồ sơ mỗi ngày (mặc định 1); cùng tiểu sử đã lưu thì không lưu lại.",
  thamSo: TS_TIEU_SU(80),
  params: {
    tieu_su_tt: { type: "string", default: "{{ts.tieu_su}}", label: "Tiểu sử TikTok (để trống = AI soạn)" },
    chu_de_ts_tt: { type: "string", default: "{{ts.chu_de}}", label: "Chủ đề tiểu sử TikTok (AI soạn)" },
  },
  trangThu: "CHƯA kiểm trên trang thật (trang cá nhân TikTok — hộp Sửa hồ sơ; CAPTCHA khi khảo sát)",
  yamlSteps: `  - id: lay_tieu_su_tt
    template: "{{tieu_su_tt}}"
    into: ts_tt

  - id: soan_tieu_su_tt
    when: "len(trim(tieu_su_tt)) == 0"
    generate:
      input: "Viết TIỂU SỬ (bio) cho hồ sơ TikTok của chính bạn về: {{chu_de_ts_tt}} — một câu rất ngắn, tối đa 80 ký tự, tự nhiên, không chèn liên kết hay số điện thoại"
      guide: knowledge
      max_words: 16
      max_chars: 80
    into: ts_tt

  - id: mo_trang_chu_ts_tt
    on: web
    do: "mở TikTok để đọc nick đang dùng"
    expect: "trang TikTok"

  - id: lay_nick_ts_tt
    on: web
    extract: "nick TikTok đang đăng nhập (liên kết Hồ sơ ở thanh bên)"
    into: nick_ts_tt
    timeout: 15s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: mo_sua_ho_so_tt
    on: web
    do: "mở trang cá nhân @{{nick_ts_tt}} rồi bấm Sửa hồ sơ"
    expect: "ô Tiểu sử hiện"

  - id: luu_tieu_su_tt
    on: web
    do: "gõ {{ts_tt}} vào ô Tiểu sử rồi bấm Lưu"
    expect: "hộp Sửa hồ sơ đóng"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_cap_nhat_tieu_su_tt`,
  learned: {
    lay_tieu_su_tt: { dung_neu_sai: dungTieuSu("ts_tt", "tieu_su_tt", "chu_de_ts_tt", 80, "TikTok") },
    soan_tieu_su_tt: { dung_neu_sai: [{ dk: "len(trim(ts_tt)) > 0", ly_do: "AI chưa soạn được tiểu sử — không lưu" }] },
    mo_trang_chu_ts_tt: { actions: [{ kind: "navigate", url: "{{goc}}" }] },
    lay_nick_ts_tt: { extract_spec: TT_NICK_SPEC },
    mo_sua_ho_so_tt: {
      actions: [
        { kind: "navigate", url: "{{goc}}@{{nick_ts_tt}}" },
        { kind: "click", target: { describe: "nút Sửa hồ sơ trên trang cá nhân của mình", ladder: [{ t: "css", sel: '[data-e2e="edit-profile-entrance"]' }, { t: "xpath", xpath: '(//button[normalize-space()="Sửa hồ sơ" or normalize-space()="Edit profile"])[1]' }] } },
      ],
      postcondition: [{ t: "url_contains", s: "/@{{nick_ts_tt}}" }, { t: "locator_visible", target: TT_O_TIEU_SU }],
    },
    luu_tieu_su_tt: {
      actions: [
        { kind: "type", target: TT_O_TIEU_SU, text: "{{ts_tt}}", clear: true },
        { kind: "click", target: { describe: "nút Lưu của hộp Sửa hồ sơ", ladder: [{ t: "css", sel: '[data-e2e="edit-profile-save"]' }, { t: "xpath", xpath: '(//*[@role="dialog"]//button[normalize-space()="Lưu" or normalize-space()="Save"])[1]' }] } },
      ],
      postcondition: [{ t: "locator_gone", target: TT_O_TIEU_SU }],
      dem_ngay: "ho_so",
    },
  },
};

/** Khối nhóm 4 theo mạng — nối vào thư viện ở src/shared/khoi-thu-vien.ts. */
export const KHOI_TIN_NHAN: Readonly<Record<"facebook" | "x" | "tiktok" | "youtube" | "reddit", KhoiMau[]>> = {
  facebook: [FB_TRA_LOI_TN],
  x: [X_TIEU_SU],
  tiktok: [TT_TRA_LOI_TN, TT_TIEU_SU],
  youtube: [],
  reddit: [],
};

export const HIEN_THI_TIN_NHAN: Readonly<Record<string, { bieuTuong: string; tenNgan: string; mauMoTa: string }>> = {
  "facebook/tra_loi_tin_nhan": { bieuTuong: "✉️", tenNgan: "Trả lời tin nhắn chưa đọc", mauMoTa: "Trả lời tối đa {so_tin} đoạn chat Messenger CHƯA ĐỌC (AI soạn như chủ tài khoản; bỏ tin rác[, người lạ khi chỉ người quen = {chi_nguoi_quen}])" },
  "tiktok/tra_loi_tin_nhan": { bieuTuong: "✉️", tenNgan: "Trả lời tin nhắn chưa đọc", mauMoTa: "Trả lời tối đa {so_tin} đoạn chat TikTok CHƯA ĐỌC (AI soạn như chủ tài khoản; bỏ tin rác[, người lạ khi chỉ người quen = {chi_nguoi_quen}])" },
  "x/cap_nhat_tieu_su": { bieuTuong: "🪪", tenNgan: "Sửa tiểu sử hồ sơ", mauMoTa: "Sửa tiểu sử hồ sơ X[ thành “{tieu_su}”][ — AI soạn về “{chu_de}”] (≤ 160 ký tự)" },
  "tiktok/cap_nhat_tieu_su": { bieuTuong: "🪪", tenNgan: "Sửa tiểu sử hồ sơ", mauMoTa: "Sửa tiểu sử hồ sơ TikTok[ thành “{tieu_su}”][ — AI soạn về “{chu_de}”] (≤ 80 ký tự)" },
};
export const NHAN_TIN_NHAN: Readonly<Record<string, string>> = {
  so_tin: "Số đoạn chat trả lời tối đa mỗi lượt",
  chi_nguoi_quen: "Chỉ trả lời người quen",
  tieu_su: "Tiểu sử (nguyên văn)",
};
